import { Component } from '@angular/core'

@Component({
    selector: 'sf-advert-cta-item-content',
    imports: [],
    template: `
        <p class="mb-0 small">
            <ng-content></ng-content>
        </p>
    `,
    host: { class: 'advert__item-text' },
})
export class AdvertCtaItemContentComponent {}
